<template>
  <div id="page-campaign-images">
    <vs-alert
      color="danger"
      title="Campaign Not Found"
      :active.sync="campaign_not_found"
    >
      <span>
        Campaign record with id
        <strong>{{ $route.params.campaignId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'campaign-list' }"
          class="text-inherit underline"
          >{{ this.$t("Campaign.List") }}</router-link
        >
      </span>
    </vs-alert>

    <div id="campaign-data" v-if="campaign_data">
      <vx-card :title="this.$t('Campaign.Title')" class="mb-base">
        <!-- Campaign -->
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{ this.$t("Campaign.Name") }}</td>
                <td>{{ campaign_data.name }}</td>
              </tr>
            </table>
          </div>
          <!-- Log Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="campaign_data.logoUrl" class="rounded w-full" />
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card :title="this.$t('Campaign.Images')" class="mb-base mt-5">
        <campaign-image-list :idCampaign="campaign_data.id" />
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import CampaignImageList from './CampaignImageList'

export default {
  data () {
    return {
      campaign_data: null,
      campaign_not_found: false
    }
  },
  components: {
    CampaignImageList
  },
  created () {
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule('campaignManagement', moduleCampaignManagement)
      moduleCampaignManagement.isRegistered = true
    }

    const campaignId = this.$route.params.campaignId
    this.$store.dispatch('campaignManagement/fetchCampaign', campaignId)
      .then(res => {
        this.campaign_data = res.data.campaign
        if (this.campaign_data === null) {
          this.campaign_not_found = true
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.campaign_not_found = true
          return
        }
        console.error(err)
      })
  }
}

</script>
